import { httpClient } from "./httpClient";

const base = "/api/ciclos";

export const listarCiclos = () => httpClient.get(base);
export const obtenerCiclo = (id) => httpClient.get(`${base}/${id}`);
export const listarCursosPorCiclo = (id) => httpClient.get(`${base}/${id}/cursos`);
export const crearCiclo = (payload) => httpClient.post(base, payload);
export const actualizarCiclo = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarCiclo = (id) => httpClient.del(`${base}/${id}`);

const ciclosService = {
  listar: listarCiclos,
  obtener: obtenerCiclo,
  listarCursosPorCiclo,
  crear: crearCiclo,
  actualizar: actualizarCiclo,
  eliminar: eliminarCiclo,
};

export default ciclosService;
